function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DEFAULT_TPL_FIELDS, ACCESS_TYPE_FLOW, TYPE_CHANGE_METADA, GA_EVENTS, isFOHDomain } from '@/js/constants';
import MyPendingsService from '@/apps/data-platform/services/tables_views/my_pendings_service';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import { changesMedatada } from '@/mixins/changes_metadata';
import { mapState } from 'vuex';
import ListTableLogs from '@/components/ListTableLogs.vue';
import ListTableMetadataCols from '@/apps/data-platform/components/ListTableMetadataColsComponent.vue';
export default {
  name: 'FormMetadataChangeResponse',
  components: {
    ListTableLogs: ListTableLogs,
    ListTableMetadataCols: ListTableMetadataCols
  },
  mixins: [changesMedatada],
  props: {
    userRequestMetadata: {
      type: Object,
      required: true
    },
    serverActualMetadata: {
      type: Object,
      required: true
    },
    isOnlyView: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      TYPE_FLOW: ACCESS_TYPE_FLOW.ACCESS,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      defaultRequestChangeFields: null,
      columnRequestChangeFields: [],
      // response from Api
      defaultActualMetadataFields: null,
      columnActualMetadataFields: [],
      alignedActualColumns: [],
      submitButton: null,
      requestChangeToSave: {},
      changes: [],
      tab: null,
      completeDescription1: '',
      completeDescription2: ''
    };
  },
  created: function created() {
    var _this = this;
    console.log("log", this.isOnlyView);
    // separe defaultTemplate and ColumnRequestChangefields
    var separeValuesRequestChange = tasks.filterDefaultTableTagsAndColumnFields(this.userRequestMetadata.fields);
    this.defaultRequestChangeFields = separeValuesRequestChange.defaultFields;
    this.columnRequestChangeFields = separeValuesRequestChange.columnFields;

    // set save to send object
    this.requestChangeToSave.applicant = window.userInfo.email;
    this.requestChangeToSave.fields = this.userRequestMetadata.fields; // tags
    var changeFields = this.defaultRequestChangeFields;
    this.requestChangeToSave.owner = changeFields ? changeFields[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue.toLowerCase() : null;
    this.requestChangeToSave.relativeResourceName = this.userRequestMetadata.relativeResourceName;
    this.requestChangeToSave.table_id = this.userRequestMetadata.tableReference.tableId;
    this.requestChangeToSave.type_flow = this.TYPE_FLOW;
    this.requestChangeToSave.tableReference = this.userRequestMetadata.tableReference;
    this.requestChangeToSave.response = this.userRequestMetadata.response;
    this.requestChangeToSave.id_firestore = this.userRequestMetadata.id_firestore;
    this.requestChangeToSave.email = this.userRequestMetadata.applicant;

    // new accept request
    this.requestChangeToSave.user = this.userRequestMetadata.applicant;
    this.requestChangeToSave.projectId = this.userRequestMetadata.tableReference.projectId;
    this.requestChangeToSave.datasetId = this.userRequestMetadata.tableReference.datasetId;
    this.requestChangeToSave.tableId = this.userRequestMetadata.tableReference.tableId;
    this.requestChangeToSave.endDate = this.userRequestMetadata.endDate;
    this.requestChangeToSave.id_firestore = this.userRequestMetadata.id_firestore;
    this.requestChangeToSave.domain_table = this.userRequestMetadata.domain_table;
    this.requestChangeToSave.index_node = this.userRequestMetadata.index_node;

    // update metadata
    this.requestChangeToSave.fields = this.userRequestMetadata.fields;

    // load server data
    var separeValuesActualMetadata = tasks.filterDefaultTableTagsAndColumnFields(this.serverActualMetadata.objects.tags);
    this.defaultActualMetadataFields = separeValuesActualMetadata.defaultFields;
    this.columnActualMetadataFields = separeValuesActualMetadata.columnFields;

    // Align columns for reliable deep-diffing because actual payload may only contain a subset
    this.alignedActualColumns = this.columnRequestChangeFields.map(function (reqCol) {
      var actualCol = _this.columnActualMetadataFields.find(function (c) {
        return c.column === reqCol.column;
      });
      return actualCol ? actualCol : reqCol; // fallback to reqCol if it's completely new
    });

    // Normaliza authorization_type en el lado actual: los tags antiguos pueden
    // no tener el campo y deep-diff solo marca ediciones cuando la clave existe
    // en ambos lados (default histórico: manual)
    var AUTH_NAME = DEFAULT_TPL_FIELDS.AUTHORIZATION_TYPE.name;
    if (this.defaultRequestChangeFields && this.defaultRequestChangeFields[AUTH_NAME] && this.defaultActualMetadataFields && !this.defaultActualMetadataFields[AUTH_NAME]) {
      this.$set(this.defaultActualMetadataFields, AUTH_NAME, {
        displayName: 'Authorization Type',
        stringValue: 'manual'
      });
    }
    this.changes = this.getChanges(this.defaultActualMetadataFields, this.defaultRequestChangeFields, this.alignedActualColumns, this.columnRequestChangeFields);
    console.log("metadatachange: ", this.requestChangeToSave);
    this.completeDescription1 = this.defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DESCRIPTION.name].stringValue + (this.defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name] && this.defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name].stringValue != 'Null' ? this.defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name].stringValue : '') + (this.defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name] && this.defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name].stringValue != 'Null' ? this.defaultActualMetadataFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name].stringValue : '');
    this.completeDescription2 = this.defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DESCRIPTION.name].stringValue + (this.defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name] && this.defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name].stringValue != 'Null' ? this.defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DESCRIPTION2.name].stringValue : '') + (this.defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name] && this.defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name].stringValue != 'Null' ? this.defaultRequestChangeFields[DEFAULT_TPL_FIELDS.DESCRIPTION3.name].stringValue : '');
  },
  methods: {
    authorizationTypeLabel: function authorizationTypeLabel(value) {
      if (!value || value === 'Null') return '—';
      if (value === 'automatic') return this.$t('my_tasks.modals.authorization_type_automatic');
      if (value === 'manual') return this.$t('my_tasks.modals.authorization_type_manual');
      return value;
    },
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      if (this.submitButton === 'ok') {
        this.approve();
      } else if (this.submitButton === 'refuse') {
        this.onRefuse();
      }
      return true;
    },
    classDiffDescription: function classDiffDescription() {
      return {
        'resaltador': this.completeDescription1 != this.completeDescription2 //this.classDiff(this.DEFAULT_TPL_FIELDS.DESCRIPTION.name) || this.classDiff(this.DEFAULT_TPL_FIELDS.DESCRIPTION2.name) || this.classDiff(this.DEFAULT_TPL_FIELDS.DESCRIPTION3.name)
      };
    },
    onAccept: function onAccept() {
      if (!this.$refs.form.validate()) {
        this.focusRequiredComponent();
        return;
      }
      var responseToSend = utils.cloneJSON(this.toCreateView);
      responseToSend.endDate = utils.dateBrowserToService(responseToSend.endDate);
      responseToSend.fieldsToDriverConnection = utils.driverConnectionFormat(responseToSend.fields);
      responseToSend.fields = utils.extractCellNameForView(responseToSend.fields); // tags_name
      // send to create view
      if (responseToSend.fields.length > 0) {
        this.$emit('submit', responseToSend);
      } else {
        tasks.toast.error('You must choose at least one row from the required column.');
      }
    },
    approve: function approve() {
      var _this2 = this;
      // prepare to send
      var responseToSend = utils.cloneJSON(this.requestChangeToSave);
      // send to create view
      var params = {
        tags: responseToSend.fields,
        id_firestore: responseToSend.id_firestore,
        response: responseToSend.response,
        index_node: responseToSend.index_node,
        domain_table: responseToSend.domain_table,
        changes: this.changes,
        source: this.userRequestMetadata.source ? this.userRequestMetadata.source : "bigquery",
        status: false
      };
      MyPendingsService.changeMetadata(params).then(function (response) {
        if (response.code === 200) {
          tasks.toast.success('Solicitud aprobada correctamente.');
          if (_this2.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.CHANGE_METADATA_MANAGEMENT,
              object: 'table',
              domain_object: responseToSend.domain_table,
              applicant: _this2.stringToHash(responseToSend.email),
              company_code: _this2.companyCode,
              id_object: responseToSend.tableReference.projectId + '.' + responseToSend.tableReference.datasetId + '.' + responseToSend.tableReference.tableId,
              status: "approved",
              hash_email: _this2.stringToHash(userInfo.email),
              module: 'data_platform'
            });
          }
          _this2.$emit('submit', _this2.requestChangeToSave);
        } else {
          tasks.toast.error(response.message);
        }
      }).catch(function (e) {
        utils.printError(e);
        //this.approve()
      });
    },
    onRefuse: function onRefuse() {
      // validate message
      if (!this.requestChangeToSave.response) {
        tasks.toast.error('Please fill response field');
        //alert('Please fill response field')
        return false;
      }
      // TODO: send to refuse
      var responseToSend = utils.cloneJSON(this.requestChangeToSave);
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer.push({
          event: GA_EVENTS.CHANGE_METADATA_MANAGEMENT,
          object: 'table',
          domain_object: responseToSend.domain_table,
          applicant: this.stringToHash(responseToSend.email),
          company_code: this.companyCode,
          id_object: responseToSend.tableReference.projectId + '.' + responseToSend.tableReference.datasetId + '.' + responseToSend.tableReference.tableId,
          status: "rejected",
          hash_email: this.stringToHash(userInfo.email),
          module: 'data_platform'
        });
      }
      this.$emit('refuse', this.requestChangeToSave);
      return true;
    },
    onCancel: function onCancel(event) {
      event.preventDefault();
      this.$emit('cancel', null);
      return true;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    // Tipo de autorización en la comparación: solo dominios FOH y, para poder
    // probarlo, siempre en entorno local
    showAuthorizationTypeCompare: function showAuthorizationTypeCompare() {
      return isFOHDomain(window.userInfo.domain) || process.env.VUE_APP_ENV === 'local' || process.env.NODE_ENV === 'development';
    }
  })
};